'use strict'

/**
 * Module Ad Blocker
 */
let adBlockEnabled = false

/**
 * Détecte si un bloquer de publicité est activé sur le poste de l'utilisateur
 */
function initAdBlockerDetection() {
    const testAd = document.createElement('div')
    testAd.innerHTML = '&nbsp;'
    testAd.className = 'adsbox'
    document.body.appendChild(testAd)
    window.setTimeout(function () {
        if (testAd.offsetHeight === 0) {
            adBlockEnabled = true
        }
        testAd.remove()
    }, 100)
}

/**
 * Retourne si un utilisateur utilisateur un bloqueur de publicité
 */
function useAdBlocker() {
    return adBlockEnabled
}

export default {
    useAdBlocker: useAdBlocker,
    initAdBlockerDetection: initAdBlockerDetection
}
